import SchoolCardResultsContainer from "./results-school-card-container";
import FilterResultsComponent from "src/components/user/filter-results-component";
import { HiOutlineAdjustments } from "react-icons/hi";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function ResearchResultsContainer() {
  const { i18n, t } = useTranslation();
  const [openFilterMobile, setOpenFilterMobile] = useState(false);
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className={`bg-zinc50 py-24 mobile:pt-10 ${
        i18n.language === "ar" ? "mobile:ml-8" : "mobile:mr-8"
      }`}
    >
      <div className="flex flex-row justify-center gap-[30px]">
        <FilterResultsComponent
          openFilterMobile={openFilterMobile}
          closeFilterMobile={() => setOpenFilterMobile(false)}
        />
        <div
          className={`flex flex-col gap-2 mobile:gap-4 ${
            openFilterMobile ? "hidden" : ""
          }`}
        >
          <div className="mobile:flex mobile:flex-row mobile:justify-between mobile:items-center tablet:flex tablet:flex-row tablet:justify-between tablet:items-center">
            <div
              className={`flex flex-col py-2.5 gap-2.5 mobile:py-0 mobile:gap-0 ${
                i18n.language === "ar" ? "mobile:w-[186px]" : "mobile:w-[230px]"
              }  mobile:pr-[13px]`}
            >
              <p className="text-xl mobile:text-base font-arBold text-zinc500">
                {t("results.component.allresult")}
              </p>
              <p
                className={`text-base w-[754px] tablet:w-[500px] mobile:text-[8px]  ${
                  i18n.language === "ar" ? "mobile:w-[186px] mobile:text-right" : "mobile:w-[220px] mobile:text-left"
                } font-arMedium text-zinc400`}
              >
                {t("results.component.preferences")}
              </p>
            </div>
            <button
              className="flex justify-center items-center w-[117px] h-10 bg-mint-500 rounded-xl text-zinc-50 text-xs font-arMedium laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden"
              onClick={() => setOpenFilterMobile(true)}
            >
              {t("results.component.filter")}
              <HiOutlineAdjustments size={16} className={`${i18n.language==="ar"? "mr-1":"ml-1"}`} />
            </button>
          </div>
          {/* School card */}
          <SchoolCardResultsContainer />
        </div>
      </div>
    </div>
  );
}

export default ResearchResultsContainer;
